import httpClient from './httpClient';
import { Seguro, CreateSeguroDto } from '../types/seguro';

export const fetchSeguros = async (): Promise<Seguro[]> => {
  try {
    const response = await httpClient.get('/api/seguros');
    const seguros = response.data;

    // Ensure we return an array
    if (!Array.isArray(seguros)) {
      console.warn('Seguros response is not an array:', seguros);
      return [];
    }

    return seguros;
  } catch (error) {
    console.error('Error fetching seguros:', error);
    throw new Error(error instanceof Error ? error.message : 'Error al obtener seguros');
  }
};

/** Examen de la póliza con los datos que necesita el modal de facturación. */
export interface ExamenCobertura {
  _id: string;
  nombre: string;
  codigo: string;
  precio: number;
  categoria?: string;
}

/**
 * Cobertura de una ARS con los exámenes poblados. `descuento` es el porcentaje
 * que se aplica al precio de lista para obtener el precio facturable.
 */
export interface CoberturaSeguro extends Omit<Seguro, 'examenesAplicables'> {
  examenesAplicables?: ExamenCobertura[];
}

export const fetchCoberturaSeguro = async (id: string): Promise<CoberturaSeguro> => {
  try {
    const response = await httpClient.get(`/api/seguros/${id}?examenes=true`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cobertura del seguro:', error);
    throw new Error(
      error instanceof Error ? error.message : 'Error al obtener la cobertura del seguro'
    );
  }
};

export const createSeguro = async (seguro: CreateSeguroDto): Promise<Seguro> => {
  try {
    const response = await httpClient.post('/api/seguros', seguro);
    return response.data;
  } catch (error) {
    console.error('Error creating seguro:', error);
    throw new Error(error instanceof Error ? error.message : 'Error al crear seguro');
  }
};

export const updateSeguro = async (id: string, seguro: Partial<CreateSeguroDto>): Promise<Seguro> => {
  try {
    const response = await httpClient.put(`/api/seguros/${id}`, seguro);
    return response.data;
  } catch (error) {
    console.error('Error updating seguro:', error);
    throw new Error(error instanceof Error ? error.message : 'Error al actualizar seguro');
  }
};

export const deleteSeguro = async (id: string): Promise<void> => {
  try {
    await httpClient.delete(`/api/seguros/${id}`);
  } catch (error) {
    console.error('Error deleting seguro:', error);
    throw new Error(error instanceof Error ? error.message : 'Error al eliminar seguro');
  }
};

export const changeSeguroStatus = async (id: string, activo: boolean): Promise<Seguro> => {
  try {
    const response = await httpClient.patch(`/api/seguros/${id}/estado`, { activo });
    return response.data;
  } catch (error) {
    console.error('Error changing seguro status:', error);
    throw new Error(error instanceof Error ? error.message : 'Error al cambiar estado del seguro');
  }
};